import { render } from "./InputItemsView.vue?vue&type=template&id=32cf8656"
import script from "./InputItemsView.vue?vue&type=script&lang=js"
export * from "./InputItemsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__